<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <b-btn size="sm" variant="primary" v-b-modal.modal-push-notif @click="initPushNotifModal">Send Push Notification</b-btn>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="notifData"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                    :row-style-class="rowStyleClassFn"
                >
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>


            <b-modal id="modal-push-notif" title="Push Notification" button-size="sm">
              <b-form-checkbox
                  id="checkbox-1"
                  v-model="allAccount"
                  name="checkbox-1"
                  value="true"
                  unchecked-value="false"
              >Semua Akun
              </b-form-checkbox>
              <div v-show="allAccount === 'true'">
                <b-form-group label="Pilih Type Akun" v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="notificationPayload.type" :aria-describedby="ariaDescribedby" value="all">Semua</b-form-radio>
                  <b-form-radio v-model="notificationPayload.type" :aria-describedby="ariaDescribedby" value="teacher">Guru</b-form-radio>
                  <b-form-radio v-model="notificationPayload.type" :aria-describedby="ariaDescribedby" value="student">Murid</b-form-radio>
                </b-form-group>
              </div>
              <label>Email:</label>
              <b-form-tags
                  :disabled="allAccount === 'true'"
                  input-id="tags-separators"
                  v-model="notificationPayload.emails"
                  separator=",;"
                  placeholder="Entert email separated by comma or semicolon"
                  no-add-on-enter
              ></b-form-tags>
              <b-form-group label="Type" v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="notificationPayload.notification_type" :aria-describedby="ariaDescribedby" value="regular">Regular</b-form-radio>
                <b-form-radio v-model="notificationPayload.notification_type" :aria-describedby="ariaDescribedby" value="web">Web</b-form-radio>
              </b-form-group>
              <div v-if="notificationPayload.notification_type === 'web'">
                <label>Link URL:</label>
                <b-input v-model="notificationPayload.link_url" placeholder="Enter Link URL"></b-input>
              </div>
              <label>Title:</label>
              <b-input v-model="notificationPayload.title" placeholder="Enter Title"></b-input>
              <label>Konten:</label>
              <b-textarea v-model="notificationPayload.content" placeholder="Enter Content"></b-textarea>
              <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel">
                  Close
                </b-button>
                <b-button size="sm" variant="primary" @click="saveNotification">
                  Submit
                </b-button>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Swal from "sweetalert2";
export default {
  name: "push_notif",
  page: {
    title: "Push Notification",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  created() {
    this.fetchNotifData()
  },
  data() {
    return {
      title: "Push Notification",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        name: '',
      },
      notifData: [],
      columns: [
        { field: "id", label: "ID" },
        { field: "email", label: "Email" },
        { field: "title", label: "Title" },
        { field: "content", label: "Konten" },
        { field: "notification_type", label: "Type" },
        { field: "link_url", label: "Link URL" },
        { field: "created_date", label: "Created Date" },
      ],
      notificationPayload: {
        emails: [],
        title: '',
        content: '',
        type: '',
        notification_type: '',
        link_url: '',
      },
      allAccount: 'false',
      accountType: ''
    }
  },
  computed: {
  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    fetchNotifData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallNotifData(params)
    },
    httpCallNotifData(params) {
      axios.get("/api/push-notif?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.notifData = data
            this.isFetched = true
          });
    },
    saveNotification() {
      if (this.allAccount === 'false' && this.notificationPayload.emails.length === 0) {
        Swal.fire('Masukkan email terlebih dahulu')
        return
      }
      axios.post("/api/push-notif", this.notificationPayload)
          .then(resp => {
            const { data, pagination } = resp.data
            Swal.fire('Sukses')
            this.fetchNotifData()
            this.$bvModal.hide('modal-push-notif')
          });
    },
    initPushNotifModal() {
      this.allAccount = 'false'
      this.notificationPayload = {
        emails: [],
        title: '',
        content: '',
        type: '',
        notification_type: '',
        link_url: '',
      }
    }
  },
  watch: {
    searchText: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        name: value,
        sort: '-id',
      })
      this.httpCallNotifData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallNotifData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallNotifData(params)
      }
    },
    allAccount: function(newValue) {
      if (newValue === 'false') {
        this.notificationPayload.type = ""
      }
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>